module.exports = __webpack_public_path__ + "media/images/ic-index-block-771c6090cbc1900a3aba07e3da8a0f66.svg";